export { default as ColorPicker } from './colorPicker'



// WEBPACK FOOTER //
// ./src/components/productTile/colorPicker/index.js